import { register } from '@shopify/theme-sections'

import '../../styles/sections/section-table-with-text.scss'

export default register(`section-table-with-text`, {

  onLoad() {
  },

  onUnload() {
  },
})
